module.exports = __webpack_public_path__ + "media/images/coupon/coupon_illustration-23322891d2f672baa0a5c88611989ec6.png";